import React from 'react'
import ReactDOM from 'react-dom'
import CloseIcon from './icons/CloseIcon.jsx'

/**
 * ConfirmDialog — a centred confirm/cancel dialog that can be rendered from anywhere.
 *
 * Portalled to document.body so a transformed/filtered ancestor (sidebar glass, dnd-kit
 * sortable items, ...) can't become its containing block and mis-position the fixed overlay.
 * Escape and clicking the backdrop both cancel.
 */
const ConfirmDialog = ({ title, children, confirmLabel, confirmKind, variant, onCancel, onConfirm, busy }) => {
  React.useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key !== 'Escape') return
      // Capture phase + stop, so an enclosing modal doesn't also close on the same Escape.
      event.stopImmediatePropagation()
      onCancel()
    }
    document.addEventListener('keydown', onKeyDown, true)
    return () => document.removeEventListener('keydown', onKeyDown, true)
  }, [onCancel])

  return ReactDOM.createPortal(
    <div
      className='manage-modal__confirm-overlay'
      onClick={event => {
        // React events bubble through the portal to the component that rendered it; keep them here.
        event.stopPropagation()
        if (event.target === event.currentTarget) onCancel()
      }}
    >
      <section
        className={`manage-modal__confirm ${variant ? `manage-modal__confirm--${variant}` : ''}`}
        role='dialog'
        aria-modal='true'
        aria-labelledby='manage-confirm-title'
      >
        <header className='manage-modal__confirm-header'>
          <h3 id='manage-confirm-title'>{title}</h3>
          <button type='button' className='manage-modal__close' onClick={onCancel} aria-label='Close'>
            <CloseIcon />
          </button>
        </header>
        <div className='manage-modal__confirm-body'>{children}</div>
        <div className='manage-modal__confirm-actions'>
          <button type='button' className='manage-modal__confirm-cancel' onClick={onCancel} disabled={busy}>
            Cancel
          </button>
          <button
            type='button'
            className={`manage-modal__confirm-submit manage-modal__confirm-submit--${confirmKind || 'navy'}`}
            onClick={onConfirm}
            disabled={busy}
          >
            {confirmLabel}
          </button>
        </div>
      </section>
    </div>,
    document.body
  )
}

export default ConfirmDialog
